import { ConditionsTitle } from "../../../constants";
import { ConditionNavListData, ConditionData } from "../../../data/pages/Other";
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import Scrollspy from "./common/scrollspy";

const ConditionContainer = () => {
  return (
    <>
      <Breadcrumbs title="Conditions" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <Scrollspy title={ConditionsTitle} list={ConditionNavListData} content={ConditionData} />
    </>
  );
};

export default ConditionContainer;
